<template>
  <div class="home">
    <h1>Home page</h1>
    <div style="margin-bottom: 50px"></div>
  </div>
</template>

<script>
  export default {
      name: 'Home'
  }
</script>
